import { FC, useEffect, useState } from 'react';
import { useFormContext } from '../../../contexts/FormContext';
import { FormType } from '../../../types/FormTypes';
import { BlogForm } from './forms/blog/BlogForm';
import { EmailForm } from './forms/email/EmailForm';
import { SocialForm } from './forms/social/SocialForm';
import { OutputTabs } from './output/OutputTabs';
import { MarketingIdeasForm } from './forms/marketingIdeas/MarketingIdeasForm';
import axios from 'axios';
import styles from './EditorPage.module.css';
import { EditorType } from '../../../types/EditorTypes';
import { ContentImproverForm } from './forms/contentImprover/ContentImproverForm';
import { AudienceRetargetForm } from './forms/audienceRetarget/AudienceRetargetForm';
import { HeroHeaderForm } from './forms/website/HeroHeaderForm';
import { SubheaderForm } from './forms/website/SubheaderForm';
import { FeatureDescriptionForm } from './forms/website/FeatureDescriptionForm';
import { CallToActionForm } from './forms/website/CallToActionForm';
import { PersonaSocialForm } from './forms/social/PersonaSocialForm';
import { PersonaMarketingIdeasForm } from './forms/marketingIdeas/PersonaMarketingIdeasForm';
import { PersonaBlogForm } from './forms/blog/PersonaBlogForm';
import { PersonaEmailForm } from './forms/email/PersonaEmailForm';
import { PersonaHeroHeaderForm } from './forms/website/PersonaHeroHeaderForm';
import { PersonaSubheaderForm } from './forms/website/PersonaSubHeaderForm';
import { PersonaCallToActionForm } from './forms/website/PersonaCallToActionForm';
import { PersonaFeatureDescriptionForm } from './forms/website/PersonaFeatureDescriptionForm';
import { PersonaTweetForm } from './forms/social/PersonaTweetForm';
import { PersonaInstaPostForm } from './forms/social/PersonaInstaPostForm';
import { PersonaFacebookPostForm } from './forms/social/PersonaFacebookPostForm';
import { PersonaLinkedInPostForm } from './forms/social/PersonaLinkedinForm';
import { ContentEngagerForm } from './forms/contentImprover/ContentEngagerForm';
import { ContentExpanderForm } from './forms/contentImprover/ContentExpanderForm';
import { ContentConciserForm } from './forms/contentImprover/ContentConciserForm';
import { PersonaNewsletterForm } from './forms/newsletter/PersonaNewsletter';
import { AudienceChangerForm } from './forms/changer/audienceChanger';
import { FormatChangerForm } from './forms/changer/formatChanger';
import { ToneChangerForm } from './forms/changer/toneChanger';
import { SeasonalHolidayForm } from './forms/other/SeasonalHoliday';
import { DiscountPromotionForm } from './forms/other/DiscountPromotion';
import { GiveAwayPromotionForm } from './forms/other/GiveAwayPromotion';
import { LinkedInCompanyBioForm } from './forms/social/LinkedInCompanyBio';
import { YoutubeChannelDescriptionForm } from './forms/social/YoutubeChannelDescription';
import { TikTokCaptionForm } from './forms/social/TikTokCaption';
import { ProductDescriptionForm } from './forms/advertisement/ProductDescription';
import { MetaAdsForm } from './forms/advertisement/MetaAd';
import { GoogleAdsForm } from './forms/advertisement/GoogleAd';
import { ValuePropForm } from './forms/other/ValueProp';
import { YoutubeVideoDescriptionForm } from './forms/social/YoutubeVideoDescription';
import { BrandMissionForm } from './forms/other/BrandMission';
import { YoutubeVideoScriptForm } from './forms/social/YoutubeVideoScript';
import { ShortVideoScriptForm } from './forms/social/ShortVideoScriptForm';
import { BasicButton } from '../../shared/buttons/BasicButton';
import { BasicPopup, BasicPopup2 } from '../../shared/popups/BasicPopup';
import { AudiencePersonaSoloPopup } from '../personasPage/AudiencePersonaPopup';
import { BrandPersonaSoloPopup } from '../personasPage/BrandPersonaPopupSolo';
import { EditAudiencePersonaPopup } from '../personasPage/EditAudiencePersonaPopup';
import { EditBrandPersonaPopup } from '../personasPage/EditBrandPersonaPopup';
import { EditProductPersonaPopup } from '../personasPage/EditProductPersonaPopup';
import { ProductPersonaSoloPopup } from '../personasPage/productPersonaPopup';
import Image from 'next/image';
import { usePersonaContext } from '../../../contexts/PersonaContext';
import { JobDescriptionForm } from './forms/humanResources/JobDescription';
import mixpanel from 'mixpanel-browser';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useSettingsContext } from '../../../contexts/SettingsContext';
import {
  SubscriptionType,
  SubscriptionLength,
} from '../../../types/Stripe.type';
import { useRouter } from 'next/router';
import { LinkedInDirectMessageForm } from './forms/social/LinkedInDirectMessageForm';

type EditorPageProps = {
  editorType: EditorType;
};

export const EditorPage: FC<EditorPageProps> = ({ editorType }) => {
  const {
    formType,
    blogInput,
    emailInput,
    personaEmailInput,
    socialInput,
    personaSocialInput,
    personaNewsletterInput,
    seasonalHolidayInput,
    discountPromotionInput,
    giveawayPromotionInput,
    linkedinCompanyBioInput,
    linkedinDirectMessageInput,
    youtubeChannelDescriptionInput,
    youtubeVideoDescriptionInput,
    shortVideoScriptInput,
    tiktokCaptionInput,
    productDescriptionInput,
    metaAdsInput,
    googleAdsInput,
    valuePropInput,
    youtubeVideoScriptInput,
    jobDescriptionInput,
  } = useFormContext();

  const { loading } = useFormContext();
  const {
    brandPersonas,
    audiencePersonas,
    productPersonas,
    deleteBrand,
    deleteProduct,
    deleteAudience,
  } = usePersonaContext();
  const { teamMembers } = useSettingsContext();
  const { userData, signOutUser } = useAuthContext();
  const router = useRouter();
  const [showBrandPopup, setShowBrandPopup] = useState(false);
  const [showAudiencePopup, setShowAudiencePopup] = useState(false);
  const [showProductPopup, setShowProductPopup] = useState(false);
  const [showEditPopup, setEditPopup] = useState(false);
  const [showDeletePopup, setDeletePopup] = useState(false);
  const [showProEditPopup, setProEditPopup] = useState(false);
  const [showProDeletePopup, setProDeletePopup] = useState(false);
  const [showAudEditPopup, setAudEditPopup] = useState(false);
  const [showAudDeletePopup, setAudDeletePopup] = useState(false);
  const [load, setLoading] = useState(false);
  const [limitMet, setLimitMet] = useState(false);
  const [tier4Met, setTier4Met] = useState(false);
  const [tier3Met, setTier3Met] = useState(false);
  const [tier2Met, setTier2Met] = useState(false);
  const [tier1Met, setTier1Met] = useState(false);
  const [hideTitle, setHideTitle] = useState(false);
  const [appSumoLimit, setAppSumoLimitMet] = useState(false);
  const [appSumoPersonaLimit, setAppSumoPersonaLimitMet] = useState(false);
  const [unsubscribed, setUnsubscribed] = useState(false);
  const [showTrialEndScreen, setShowTrialEndScreen] = useState(false);
  const [showUpgradeScreen, setShowUpgradeScreen] = useState(false);
  const [showUpgradeScreen2, setShowUpgradeScreen2] = useState(false);
  const [showFT2SOLO, setShowFT2SOLO] = useState(false);
  const [showFT2TEAM1, setShowFT2TEAM1] = useState(false);

  const [v1, setv1] = useState('');
  const [id, setv2] = useState('');
  const [v3, setv3] = useState('');
  const [v4, setv4] = useState(['']);
  const [v5, setv5] = useState('');
  const [v6, setv6] = useState('');
  const [v7, setv7] = useState('');
  const [v8, setv8] = useState('');
  const [v9, setv9] = useState(['']);
  const [v10, setv10] = useState([{ replaceThis: '', withThis: '' }]);
  const [v11, setv11] = useState(['']);
  const [p1, setp1] = useState('');
  const [p2, setp2] = useState('');
  const [p3, setp3] = useState('');
  const [p4, setp4] = useState({ value: '', label: '' });
  const [a1, seta1] = useState('');
  const [a2, seta2] = useState({ value: '', label: '' });
  const [a3, seta3] = useState(['']);
  const [a4, seta4] = useState(['']);
  const [a5, seta5] = useState(['']);
  const [a6, seta6] = useState(['']);
  const [a7, seta7] = useState('');
  const [a8, seta8] = useState('');
  const [a9, seta9] = useState('');
  const [a10, seta10] = useState('');
  const [a11, seta11] = useState('');
  const [a12, seta12] = useState('');

  const updatePersonaData = (
    v1: string,
    id: string,
    v3: string,
    v4: string[],
    v5: string,
    v6: string,
    v7: string,
    v8: string,
    v9: string[],
    v10: { replaceThis: string; withThis: string }[],
    v11: string[],
    p1: string,
    p2: string,
    p3: string,
    p4: { value: string; label: string },
    a1: string,
    a2: { value: string; label: string },
    a3: string[],
    a4: string[],
    a5: string[],
    a6: string[],
    a7: string,
    a8: string,
    a9: string,
    a10: string,
    a11: string,
    a12: string,
    neededMenu: string
  ) => {
    // console.log(v1, id, v3, p1, neededMenu);
    console.log('clicked!');
    // Perform asynchronous operations, such as fetching data from an API

    setv1(v1);
    setv2(id);
    setv3(v3);
    setv4(v4);
    setv5(v5);
    setv6(v6);
    setv7(v7);
    setv8(v8);
    setv9(v9);
    setv10(v10);
    setv11(v11);
    seta1(a1); //audience
    seta2(a2); // brand
    seta3(a3); //gender
    seta4(a4); //age
    seta5(a5); //occupation
    seta6(a6); //location
    seta7(a7); //painpoint
    seta8(a8); //id
    seta9(a9);
    seta10(a10);
    seta11(a11);
    seta12(a12);
    setp1(p1); //product
    setp2(p2); // description
    setp3(p3); //id
    setp4(p4); //brand
    if (neededMenu === 'BrandCreate') {
      if (userData?.stripe?.subscriptionType === SubscriptionType.FREE_TRIAL) {
        setShowFT2TEAM1(true);
        mixpanel.track('Upgrade from FT to Team Popup Opened', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.SOLO &&
        brandPersonas &&
        brandPersonas?.length > 0
      ) {
        setShowUpgradeScreen(true);
        mixpanel.track('Upgrade to Pro Popup Opened', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TEAM &&
        brandPersonas &&
        brandPersonas?.length > 2
      ) {
        setShowUpgradeScreen2(true);
        mixpanel.track('Upgrade to Agency Popup Opened', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER1_2 &&
        brandPersonas &&
        brandPersonas?.length > 0
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Brand Persona Limit Popup Opened - Tier 1', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER2_2 &&
        brandPersonas &&
        brandPersonas?.length > 2
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Brand Persona Limit Popup Opened - Tier 2', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER3_2 &&
        brandPersonas &&
        brandPersonas?.length > 9
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Brand Persona Limit Popup Opened - Tier 3', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER4_2 &&
        brandPersonas &&
        brandPersonas?.length > 19
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Brand Persona Limit Popup Opened - Tier 4', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else {
        setShowBrandPopup(true);
        mixpanel.track('Brand Persona Creation Started', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      }
    }
    if (neededMenu === 'BrandEdit') {
      setEditPopup(true);
      mixpanel.track('Brand Persona Edit Started', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
    }
    if (neededMenu === 'BrandDelete') {
      setDeletePopup(true);
      mixpanel.track('Brand Persona Deleted', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
    }
    if (neededMenu === 'ProductCreate') {
      setShowProductPopup(true);
      mixpanel.track('Product Persona Creation Started', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
    }
    if (neededMenu === 'ProductEdit') {
      setProEditPopup(true);
      mixpanel.track('Product Persona Edit Started', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
    }
    if (neededMenu === 'ProductDelete') {
      mixpanel.track('Product Persona Deleted', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
      setProDeletePopup(true);
    }
    if (neededMenu === 'AudienceCreate') {
      if (
        userData?.stripe?.subscriptionType === SubscriptionType.FREE_TRIAL &&
        audiencePersonas?.length === 6
      ) {
        setShowFT2TEAM1(true);
        mixpanel.track('Upgrade to Pro Popup Opened - Audience', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.SOLO &&
        audiencePersonas &&
        audiencePersonas?.length > 5
      ) {
        setShowUpgradeScreen(true);
        mixpanel.track('Upgrade to Pro Popup Opened', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER1_2 &&
        audiencePersonas &&
        audiencePersonas?.length > 2
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Audience Persona Limit Popup Opened - Tier 1', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER2_2 &&
        audiencePersonas &&
        audiencePersonas?.length > 4
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Audience Persona Limit Popup Opened - Tier 2', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER3_2 &&
        audiencePersonas &&
        audiencePersonas?.length > 9
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo Audience Persona Limit Popup Opened - Tier 3', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else if (
        userData?.stripe?.subscriptionType === SubscriptionType.TIER4_2 &&
        audiencePersonas &&
        audiencePersonas?.length > 19
      ) {
        setAppSumoPersonaLimitMet(true);
        mixpanel.track('AppSumo audience Persona Limit Popup Opened - Tier 4', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      } else {
        mixpanel.track('Audience Persona Creation Started', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
        setShowAudiencePopup(true);
      }
    }
    if (neededMenu === 'AudienceEdit') {
      mixpanel.track('Audience Persona Edit Started', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
      setAudEditPopup(true);
    }
    if (neededMenu === 'AudienceDelete') {
      mixpanel.track('Audience Persona Deleted', {
        email: userData?.email,
        displayName: userData?.displayName,
      });
      setAudDeletePopup(true);
    }
  };

  const closeBrand = () => {
    // Handle the close event here
    setShowBrandPopup(false);
  };

  const closeEditBrand = () => {
    setEditPopup(false);
  };

  const closeProduct = () => {
    // Handle the close event here
    setShowProductPopup(false);
  };

  const closeEditProduct = () => {
    setProEditPopup(false);
  };

  const closeAudience = () => {
    // Handle the close event here
    setShowAudiencePopup(false);
  };

  const closeEditAudience = () => {
    setAudEditPopup(false);
  };

  const upgradeToTeamTier = async (
    email: string,
    subscription: string,
    subscriptionLength: string,
    subscriptionType: string,
    startDate: FirebaseFirestore.Timestamp,
    customerID: string,
    subItemID: string
  ) => {
    setLoading(true);
    await axios.post('/api/stripe/upgradeToTeam', {
      email,
      subscription,
      subscriptionLength,
      subscriptionType,
      startDate,
      customerID,
      subItemID,
    });
    location.reload();
    setLoading(false);
  };

  const getEditor = () => {
    if (editorType === EditorType.CONTENT) {
      switch (formType) {
        case FormType.BLOG:
          return blogInput && <BlogForm />;
        default:
        case FormType.PERSONABLOG:
          return <PersonaBlogForm onButtonClick={updatePersonaData} />;
        case FormType.EMAIL:
          return emailInput && <EmailForm />;
        case FormType.PERSONAEMAIL:
          return (
            personaEmailInput && (
              <PersonaEmailForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.EMAIL_SUBJECT_LINES:
          return (
            personaEmailInput && (
              <PersonaEmailForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PROSPECTING_EMAIL:
          return (
            personaEmailInput && (
              <PersonaEmailForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.OUTREACH_EMAIL:
          return (
            personaEmailInput && (
              <PersonaEmailForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.REENGAGEMENT_EMAIL:
          return (
            personaEmailInput && (
              <PersonaEmailForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.FOLLOWUP_EMAIL:
          return (
            personaEmailInput && (
              <PersonaEmailForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.SOCIAL:
          return socialInput && <SocialForm />;
        case FormType.PERSONA:
          return personaSocialInput && <PersonaSocialForm />;
        case FormType.PERSONA_TWITTER:
          return (
            personaSocialInput && (
              <PersonaTweetForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PERSONA_INSTAGRAM:
          return (
            personaSocialInput && (
              <PersonaInstaPostForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PERSONA_FACEBOOK:
          return (
            personaSocialInput && (
              <PersonaFacebookPostForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PERSONA_LINKEDIN:
          return (
            personaSocialInput && (
              <PersonaLinkedInPostForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PERSONA_NEWSLETTER:
          return (
            personaNewsletterInput && (
              <PersonaNewsletterForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PROMOTIONAL_NEWSLETTER:
          return (
            personaNewsletterInput && (
              <PersonaNewsletterForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.PRODUCT_UPDATE_NEWSLETTER:
          return (
            personaNewsletterInput && (
              <PersonaNewsletterForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.EDUCATIONAL_NEWSLETTER:
          return (
            personaNewsletterInput && (
              <PersonaNewsletterForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.ORGANIZATIONAL_NEWSLETTER:
          return (
            personaNewsletterInput && (
              <PersonaNewsletterForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.SEASONAL:
          return (
            seasonalHolidayInput && (
              <SeasonalHolidayForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.DISCOUNT:
          return (
            discountPromotionInput && (
              <DiscountPromotionForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.GIVEAWAY:
          return (
            giveawayPromotionInput && (
              <GiveAwayPromotionForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.LINKEDIN_COMPANY_BIO:
          return (
            linkedinCompanyBioInput && (
              <LinkedInCompanyBioForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.LINKEDIN_DIRECT_MESSAGE:
          return (
            linkedinDirectMessageInput && (
              <LinkedInDirectMessageForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.YOUTUBE_CHANNEL_DESCRIPTION:
          return (
            youtubeChannelDescriptionInput && (
              <YoutubeChannelDescriptionForm
                onButtonClick={updatePersonaData}
              />
            )
          );
        case FormType.YOUTUBE_VIDEO_DESCRIPTION:
          return (
            youtubeVideoDescriptionInput && (
              <YoutubeVideoDescriptionForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.SHORT_VIDEO_SCRIPT:
          return (
            shortVideoScriptInput && (
              <ShortVideoScriptForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.TIKTOK:
          return (
            tiktokCaptionInput && (
              <TikTokCaptionForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.YOUTUBE_VIDEO_SCRIPT:
          return (
            youtubeVideoScriptInput && (
              <YoutubeVideoScriptForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.JOB_DESCRIPTION:
          return (
            jobDescriptionInput && (
              <JobDescriptionForm onButtonClick={updatePersonaData} />
            )
          );
        case FormType.META_ADS:
          return (
            metaAdsInput && <MetaAdsForm onButtonClick={updatePersonaData} />
          );
        case FormType.GOOGLE_ADS:
          return (
            googleAdsInput && (
              <GoogleAdsForm onButtonClick={updatePersonaData} />
            )
          );
      }
    } else if (editorType === EditorType.BRAINSTORM) {
      switch (formType) {
        case FormType.MARKETINGIDEAS:
          return <MarketingIdeasForm />;
        case FormType.PERSONAMARKETINGIDEAS:
          return (
            <PersonaMarketingIdeasForm onButtonClick={updatePersonaData} />
          );
      }
    } else if (editorType === EditorType.TOOLKIT) {
      switch (formType) {
        case FormType.CONTENT_IMPROVER:
          return <ContentImproverForm />;
        case FormType.CONTENT_ENGAGER:
          return <ContentEngagerForm />;
        case FormType.CONTENT_EXPANDER:
          return <ContentExpanderForm />;
        case FormType.CONTENT_CONCISER:
          return <ContentConciserForm />;
        case FormType.AUDIENCE_RETARGET:
          return <AudienceRetargetForm />;
        case FormType.AUDIENCE_CHANGER:
          return <AudienceChangerForm onButtonClick={updatePersonaData} />;
        case FormType.FORMAT_CHANGER:
          return <FormatChangerForm />;
        case FormType.TONE_CHANGER:
          return <ToneChangerForm />;
        case FormType.PRODUCT_DESCRIPTION:
          return <ProductDescriptionForm onButtonClick={updatePersonaData} />;
        case FormType.VALUE_PROP:
          return <ValuePropForm onButtonClick={updatePersonaData} />;
        case FormType.BRAND_MISSION:
          return <BrandMissionForm onButtonClick={updatePersonaData} />;
      }
    } else if (editorType === EditorType.WEBSITE) {
      switch (formType) {
        case FormType.HERO_HEADER:
          return <HeroHeaderForm />;
        case FormType.PERSONA_HERO_HEADER:
          return <PersonaHeroHeaderForm onButtonClick={updatePersonaData} />;
        case FormType.SUBHEADER:
          return <SubheaderForm />;
        case FormType.PERSONA_SUBHEADER:
          return <PersonaSubheaderForm onButtonClick={updatePersonaData} />;
        case FormType.FEATURE_DESCRIPTION:
          return <FeatureDescriptionForm />;
        case FormType.PERSONA_FEATURE_DESCRIPTION:
          return (
            <PersonaFeatureDescriptionForm onButtonClick={updatePersonaData} />
          );
        case FormType.CALL_TO_ACTION:
          return <CallToActionForm />;
        case FormType.PERSONA_CALL_TO_ACTION:
          return <PersonaCallToActionForm onButtonClick={updatePersonaData} />;
      }
    }
  };

  const sumOfWordLimits: number = teamMembers.reduce(
    (sum, member) => sum + member.wordLimit,
    0
  );
  const subscriptionType = userData?.stripe?.subscriptionType;
  const subscriptionLength = userData?.stripe?.subscriptionLength;

  useEffect(() => {
    if (subscriptionLength === 'appsumo') {
      let limitMet = false;
      if (subscriptionType === 'TIER1' && sumOfWordLimits > 15000) {
        limitMet = true;
      } else if (subscriptionType === 'TIER2' && sumOfWordLimits > 75000) {
        limitMet = true;
      } else if (subscriptionType === 'TIER3' && sumOfWordLimits > 300000) {
        limitMet = true;
      } else if (subscriptionType === 'TIER1_2' && sumOfWordLimits > 15000) {
        limitMet = true;
      } else if (subscriptionType === 'TIER2_2' && sumOfWordLimits > 75000) {
        limitMet = true;
      } else if (subscriptionType === 'TIER3_2' && sumOfWordLimits > 300000) {
        limitMet = true;
      } else if (subscriptionType === 'TIER4_2' && sumOfWordLimits > 500000) {
        limitMet = true;
      }
      setAppSumoLimitMet(limitMet);
    }
  }, [userData, sumOfWordLimits]);
  useEffect(() => {
    if (userData?.trialOver === true && userData.subscribed === false) {
      setShowTrialEndScreen(true);
    }
  }, [userData]);

  useEffect(() => {
    if (userData?.freeTrial === true && userData.wordLimit) {
      if (userData.wordLimit > 15000) {
        setShowFT2SOLO(true);
        mixpanel.track('Upgrade from FT to Solo Popup Opened', {
          email: userData?.email,
          displayName: userData?.displayName,
        });
      }
    } else {
      if (
        userData?.stripe?.subscriptionType === SubscriptionType.LIMITED &&
        userData?.wordLimit
      ) {
        if (userData?.wordLimit > 15000) {
          setLimitMet(true);
        }
      }
    }
  }, [userData]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER3) {
      if (sumOfWordLimits > 300000) {
        setTier3Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER2) {
      if (sumOfWordLimits > 75000) {
        setTier2Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER1) {
      if (sumOfWordLimits > 15000) {
        setTier1Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER1_2) {
      if (sumOfWordLimits > 15000) {
        setTier1Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER2_2) {
      if (sumOfWordLimits > 75000) {
        setTier2Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER3_2) {
      if (sumOfWordLimits > 300000) {
        setTier3Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  useEffect(() => {
    if (userData?.stripe?.subscriptionType === SubscriptionType.TIER4_2) {
      if (sumOfWordLimits > 500000) {
        setTier4Met(true);
      }
    }
  }, [userData, sumOfWordLimits]);

  return (
    <div className={styles['container']}>
      {tier1Met && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h3>You have reached your word limit!</h3>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h3>15,000/15,000 words generated.</h3>
                </div>
                <div>
                  <p>Please wait till the new month for a word refresh!</p>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Sign out"
                  onClick={() => {
                    signOutUser();
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {tier2Met && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h3>You have reached your word limit!</h3>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h3>75,000/75,000 words generated.</h3>
                </div>
                <div>
                  <p>Please wait till the new month for a word refresh!</p>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Sign out"
                  onClick={() => {
                    signOutUser();
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {tier3Met && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h3>You have reached your word limit!</h3>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h3>300,000/300,000 words generated.</h3>
                </div>
                <div>
                  <p>Please wait till the new month for a word refresh!</p>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Sign out"
                  onClick={() => {
                    signOutUser();
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {tier4Met && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h3>You have reached your word limit!</h3>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h3>500,000/500,000 words generated.</h3>
                </div>
                <div>
                  <p>Please wait till the new month for a word refresh!</p>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Sign out"
                  onClick={() => {
                    signOutUser();
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {appSumoPersonaLimit && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container']}>
            <div className={styles['popup-header-container']}>
              <h3>Persona Limit</h3>
              <button onClick={() => setAppSumoPersonaLimitMet(false)}>
                <Image
                  src="/icons/CloseBlack.svg"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={24}
                  width={24}
                />
              </button>
            </div>
            <div className={styles['center']}>
              <div>
                <div className={styles['DeleteText']}>
                  <b>You've reached your limit for personas!</b>
                </div>
                <div className={styles['DeleteText']}>
                  <p>
                    Upgrade to create more personas and unlock more features!
                  </p>
                </div>

                <div className={styles['DeleteButtons']}>
                  <BasicButton
                    theme="dark"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Cancel"
                    onClick={() => {
                      setAppSumoPersonaLimitMet(false);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </BasicPopup2>
      )}
      {limitMet && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h3>You have reached your trial word limit</h3>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h3>15,000/15,000 words generated.</h3>
                </div>
                <div>
                  <p>Keep the creative juices flowing!</p>
                </div>
                <div>
                  <p>Upgrade now to unlock more content generation!</p>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Schedule a demo"
                  onClick={() => {
                    router.push('https://calendly.com/supercopy/30min');
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="blue"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="See Options"
                  image={{
                    src: '/icons/Emoji Happy Smile.svg',
                    height: 16,
                    width: 16,
                  }}
                  onClick={async () => {
                    await router.push('/pricing');
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Sign out"
                  onClick={() => {
                    signOutUser();
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {showTrialEndScreen && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h3>Your Trial has ended.</h3>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <b>
                    Hey there! In order to keep generating content and access
                    your personas, you will need to upgrade your account to a
                    paid subscription.
                  </b>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Schedule a demo"
                  onClick={() => {
                    router.push('https://calendly.com/supercopy/30min');
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="blue"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="See Options"
                  image={{
                    src: '/icons/Emoji Happy Smile.svg',
                    height: 16,
                    width: 16,
                  }}
                  onClick={async () => {
                    await router.push('/afterTrialPricing');
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="dark"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Sign out"
                  onClick={() => {
                    signOutUser();
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {showUpgradeScreen && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h2>Upgrade</h2>
                <button onClick={() => setShowUpgradeScreen(false)}>
                  <Image
                    src="/icons/CloseBlack.svg"
                    alt="Close"
                    layout="fixed"
                    objectFit="contain"
                    height={24}
                    width={24}
                  />
                </button>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h2>
                    Uh oh! You have reached your <u>max number of personas</u>.
                  </h2>
                </div>
                <div id="columns" className={styles['upgradeDisplay']}>
                  <div id="left" className={styles['leftUpgrade']}>
                    <h2>Current Tier</h2>
                    {userData?.stripe?.subscriptionLength ===
                    SubscriptionLength.MONTHLY ? (
                      <b>$29/monthly</b>
                    ) : (
                      <b>$288/yearly</b>
                    )}
                    <div className={styles['upgrade-points']}>
                      <p>🌐 1 Brand Persona</p>
                      <p>😟 6 Audience Personas</p>
                      <p>👤 1 Seat</p>
                      <p>🔡 Unlimited Copy</p>
                    </div>
                  </div>
                  <div id="mid" className={styles['midUpgrade']}>
                    <Image
                      src="/icons/ArrowRightBlack.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={24}
                      width={24}
                    />
                  </div>
                  <div id="right" className={styles['rightUpgrade']}>
                    <h2>Pro Tier</h2>
                    {userData?.stripe?.subscriptionLength ===
                    SubscriptionLength.MONTHLY ? (
                      <b>$79/monthly</b>
                    ) : (
                      <b>$768/yearly</b>
                    )}
                    <div className={styles['upgrade-points']}>
                      <p>
                        🌐 <b>3</b> Brand Persona
                      </p>
                      <p>
                        😊 <b>Unlimited</b> Audience Personas
                      </p>
                      <p>
                        👤 <b>3+</b> Seat
                      </p>
                      <p>🔡 Unlimited Copy</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="white"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Maybe Later"
                  image={{
                    src: '/icons/CloseBlack.svg',
                    height: 18,
                    width: 18,
                  }}
                  onClick={() => {
                    setShowUpgradeScreen(!showUpgradeScreen);
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="blue"
                  type="button"
                  loading={load}
                  disabled={load}
                  image={{
                    src: '/icons/Emoji Happy Smile.svg',
                    height: 18,
                    width: 18,
                  }}
                  text="Upgrade Subscription"
                  onClick={async () => {
                    await upgradeToTeamTier(
                      userData?.email ?? '',
                      userData?.stripe?.subscription ?? '',
                      userData?.stripe?.subscriptionLength ?? '',
                      userData?.stripe?.subscriptionType ?? '',
                      userData?.startDate ?? FirebaseFirestore.Timestamp.now(),
                      userData?.stripe?.customerID ?? '',
                      userData?.stripe?.mainSubID ?? ''
                    );
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {showUpgradeScreen2 && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h2>Upgrade</h2>
                <button onClick={() => setShowUpgradeScreen2(false)}>
                  <Image
                    src="/icons/CloseBlack.svg"
                    alt="Close"
                    layout="fixed"
                    objectFit="contain"
                    height={24}
                    width={24}
                  />
                </button>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h2>
                    Uh oh! You have reached your <u>max number of personas</u>.
                  </h2>
                </div>
                <div id="columns" className={styles['upgradeDisplay']}>
                  <div id="left" className={styles['leftUpgrade']}>
                    <h2>Current Tier</h2>
                    {userData?.stripe?.subscriptionLength ===
                    SubscriptionLength.MONTHLY ? (
                      <b>$79/monthly</b>
                    ) : (
                      <b>$768/yearly</b>
                    )}
                    <div className={styles['upgrade-points']}>
                      <p>🌐 3 Brand Persona</p>
                      <p>😟 Unlimited Audience Personas</p>
                      <p>👤 Up to 5 Seats</p>
                      <p>🔡 Unlimited Copy</p>
                    </div>
                  </div>
                  <div id="mid" className={styles['midUpgrade']}>
                    <Image
                      src="/icons/ArrowRightBlack.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={24}
                      width={24}
                    />
                  </div>
                  <div id="right" className={styles['rightUpgrade']}>
                    <h2>Agency Tier</h2>
                    <b>Starting at $149/monthly </b>
                    <div className={styles['upgrade-points']}>
                      <p>
                        🌐 <b>Unlimited</b> Brand Persona
                      </p>
                      <p>
                        😊 <b>Unlimited</b> Audience Personas
                      </p>
                      <p>
                        👤 <b>5+</b> Seat
                      </p>
                      <p>🔡 Unlimited Copy</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="white"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Maybe Later"
                  image={{
                    src: '/icons/CloseBlack.svg',
                    height: 18,
                    width: 18,
                  }}
                  onClick={() => {
                    setShowUpgradeScreen2(!showUpgradeScreen2);
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="blue"
                  type="button"
                  loading={false}
                  disabled={false}
                  image={{
                    src: '/icons/Emoji Happy Smile.svg',
                    height: 18,
                    width: 18,
                  }}
                  text="Upgrade Subscription"
                  onClick={async () => {
                    await router.push(
                      'https://supercopy.typeform.com/to/dNc9IVAt'
                    );
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {showFT2SOLO && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h2>Upgrade</h2>
                <button onClick={() => setShowFT2SOLO(false)}>
                  <Image
                    src="/icons/CloseBlack.svg"
                    alt="Close"
                    layout="fixed"
                    objectFit="contain"
                    height={24}
                    width={24}
                  />
                </button>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h2>
                    Uh oh! You have reached your <u>max word limit</u>.
                  </h2>
                </div>
                <div id="columns" className={styles['upgradeDisplay']}>
                  <div id="left" className={styles['leftUpgrade']}>
                    <h2>Current Tier</h2>
                    <b>Free Trial</b>
                    <div className={styles['upgrade-points']}>
                      <p>🌐 1 Brand Persona</p>
                      <p>😟 6 Audience Personas</p>
                      <p>👤 1 Seat</p>
                      <p>🔡 15K Word Limit</p>
                    </div>
                  </div>
                  <div id="mid" className={styles['midUpgrade']}>
                    <Image
                      src="/icons/ArrowRightBlack.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={24}
                      width={24}
                    />
                  </div>
                  <div id="right" className={styles['rightUpgrade']}>
                    <h2>Solo Tier</h2>
                    <b>$29/monthly or $288/yearly</b>
                    <div className={styles['upgrade-points']}>
                      <p>
                        🌐 <b>1</b> Brand Persona
                      </p>
                      <p>
                        😊 <b>6</b> Audience Personas
                      </p>
                      <p>
                        👤 <b>1</b> Seat
                      </p>
                      <p>
                        🔡 <u>Unlimited</u> Copy
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="white"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Maybe Later"
                  image={{
                    src: '/icons/CloseBlack.svg',
                    height: 18,
                    width: 18,
                  }}
                  onClick={() => {
                    setShowFT2SOLO(!showFT2SOLO);
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="blue"
                  type="button"
                  loading={loading}
                  disabled={loading}
                  image={{
                    src: '/icons/Emoji Happy Smile.svg',
                    height: 18,
                    width: 18,
                  }}
                  text="Upgrade Subscription"
                  onClick={async () => {
                    await router.push('/pricing');
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {showFT2TEAM1 && (
        <div className={styles['popup']}>
          <BasicPopup id="persona-popup">
            <div className={styles['popup-container']}>
              <div className={styles['popup-header-container']}>
                <h2>Upgrade</h2>
                <button onClick={() => setShowFT2TEAM1(false)}>
                  <Image
                    src="/icons/CloseBlack.svg"
                    alt="Close"
                    layout="fixed"
                    objectFit="contain"
                    height={24}
                    width={24}
                  />
                </button>
              </div>
              <div className={styles['TrialText2']}>
                <div>
                  <h2>
                    Uh oh! You have reached your <u>max number of personas</u>.
                  </h2>
                </div>
                <div id="columns" className={styles['upgradeDisplay']}>
                  <div id="left" className={styles['leftUpgrade']}>
                    <h2>Current Tier</h2>
                    <b>Free Trial</b>
                    <div className={styles['upgrade-points']}>
                      <p>🌐 1 Brand Persona</p>
                      <p>😟 6 Audience Personas</p>
                      <p>👤 1 Seat</p>
                      <p>🔡 15K Word Limit</p>
                    </div>
                  </div>
                  <div id="mid" className={styles['midUpgrade']}>
                    <Image
                      src="/icons/ArrowRightBlack.svg"
                      alt="Close"
                      layout="fixed"
                      objectFit="contain"
                      height={24}
                      width={24}
                    />
                  </div>
                  <div id="right" className={styles['rightUpgrade']}>
                    <h2>Pro Tier</h2>
                    <b>$79/monthly or $768/yearly</b>
                    <div className={styles['upgrade-points']}>
                      <p>
                        🌐 <b>3</b> Brand Persona
                      </p>
                      <p>
                        😊 <b>Unlimited</b> Audience Personas
                      </p>
                      <p>
                        👤 <b>3+</b> Seat
                      </p>
                      <p>
                        🔡 <u>Unlimited</u> Copy
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['TrialButtons']}>
                <BasicButton
                  theme="white"
                  type="button"
                  loading={false}
                  disabled={false}
                  text="Maybe Later"
                  image={{
                    src: '/icons/CloseBlack.svg',
                    height: 18,
                    width: 18,
                  }}
                  onClick={() => {
                    setShowFT2TEAM1(!showFT2TEAM1);
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />{' '}
                <span>&nbsp;</span> <span>&nbsp;</span>
                <BasicButton
                  theme="blue"
                  type="button"
                  loading={loading}
                  disabled={loading}
                  image={{
                    src: '/icons/Emoji Happy Smile.svg',
                    height: 18,
                    width: 18,
                  }}
                  text="Upgrade Subscription"
                  onClick={async () => {
                    await router.push('/pricing');
                  }}
                  extraStyles={
                    {
                      // width: '150%',
                    }
                  }
                />
              </div>
            </div>
          </BasicPopup>
        </div>
      )}
      {showBrandPopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container']}>
            <div className={styles['inner']}>
              {<BrandPersonaSoloPopup onClose={closeBrand} />}
            </div>
          </div>
        </BasicPopup2>
      )}
      {showEditPopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container']}>
            <div className={styles['inner']}>
              {
                <EditBrandPersonaPopup
                  brand={v1}
                  tone={v4}
                  industry={v5}
                  profilePic={v3}
                  id={id}
                  website={v6}
                  description={v7}
                  brandPositioning={v8}
                  brandNoNoWords={v9}
                  brandReplacementWords={v10}
                  brandUseSparinglyWords={v11}
                  onClose={closeEditBrand}
                />
              }
            </div>
          </div>
        </BasicPopup2>
      )}
      {showDeletePopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container']}>
            <div className={styles['popup-header-container']}>
              <button onClick={() => setDeletePopup(false)}>
                <Image
                  src="/icons/CloseBlack.svg"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={24}
                  width={24}
                />
              </button>
            </div>
            <div className={styles['center']}>
              <div>
              <div
                  className={styles['DeleteText']}
                  style={{ textAlign: 'center' }}
                >
                  <b>
                    Are you sure you want to remove this brand persona?
                    <br />
                    <span
                      style={{
                        display: 'block',
                        fontWeight: 'normal',
                        marginTop: '3px',
                      }}
                    >
                      This action is <strong>permanent</strong>.
                    </span>
                    <span
                      style={{
                        display: 'block',
                        fontWeight: 'normal',
                        marginTop: '3px',
                      }}
                    >
                      Your team will lose access to this persona.
                    </span>
                    <span
                      style={{
                        display: 'block',
                        fontWeight: 'normal',
                        marginTop: '3px',
                      }}
                    >
                      All linked audience personas will be deleted.
                    </span>
                  </b>
                </div>
                <div className={styles['DeleteButtons']}>
                  <BasicButton
                    theme="dark"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Cancel"
                    onClick={() => {
                      setDeletePopup(!showDeletePopup);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />{' '}
                  <span>&nbsp;</span> <span>&nbsp;</span>
                  <BasicButton
                    theme="red"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Delete"
                    image={{
                      src: '/icons/DeleteWhite.svg',
                      height: 16,
                      width: 16,
                    }}
                    onClick={async () => {
                      await deleteBrand({ id });
                      setDeletePopup(!showDeletePopup);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </BasicPopup2>
      )}
      {showProductPopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container4']}>
            <div className={styles['popup-header-container']}>
              <h3>Product Persona Creation</h3>
              <button onClick={() => setShowProductPopup(false)}>
                <Image
                  src="/icons/CloseBlack.svg"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={24}
                  width={24}
                />
              </button>
            </div>
            <div className={styles['inner2']}>
              {<ProductPersonaSoloPopup onClose={closeProduct} />}
            </div>
          </div>
        </BasicPopup2>
      )}
      {showProEditPopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container4']}>
            <div className={styles['popup-header-container']}>
              <h3>Product Persona Creation</h3>
              <button onClick={() => setProEditPopup(false)}>
                <Image
                  src="/icons/CloseBlack.svg"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={24}
                  width={24}
                />
              </button>
            </div>
            <div className={styles['inner2']}>
              {
                <EditProductPersonaPopup
                  brand={p4}
                  id={p3}
                  product={p1}
                  description={p2}
                  onClose={closeEditProduct}
                />
              }
            </div>
          </div>
        </BasicPopup2>
      )}
      {showProDeletePopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container']}>
            <div className={styles['popup-header-container']}>
              <button onClick={() => setProDeletePopup(false)}>
                <Image
                  src="/icons/CloseBlack.svg"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={24}
                  width={24}
                />
              </button>
            </div>
            <div className={styles['center']}>
              <div>
                <div className={styles['DeleteText']}>
                  <b>Are you sure you want to delete this persona?</b>
                </div>
                <div className={styles['DeleteButtons']}>
                  <BasicButton
                    theme="dark"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Cancel"
                    onClick={() => {
                      setProDeletePopup(!showProDeletePopup);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />{' '}
                  <span>&nbsp;</span> <span>&nbsp;</span>
                  <BasicButton
                    theme="red"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Delete"
                    image={{
                      src: '/icons/DeleteWhite.svg',
                      height: 16,
                      width: 16,
                    }}
                    onClick={async () => {
                      const id = p3;
                      await deleteProduct({ id });
                      setProDeletePopup(!showProDeletePopup);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </BasicPopup2>
      )}
      {showAudiencePopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container2']}>
            <div className={styles['inner']}>
              {<AudiencePersonaSoloPopup onClose={closeAudience} />}
            </div>
          </div>
        </BasicPopup2>
      )}
      {showAudEditPopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container2']}>
            <div className={styles['inner']}>
              {
                <EditAudiencePersonaPopup
                  brand={a2}
                  id={a8}
                  audience={a1}
                  age={a4}
                  occupation={a5}
                  location={a6}
                  painpoints={a7}
                  gender={a3}
                  goals={a9}
                  barriers={a10}
                  triggers={a11}
                  profilePic={a12}
                  onClose={closeEditAudience}
                />
              }
            </div>
          </div>
        </BasicPopup2>
      )}
      {showAudDeletePopup && (
        <BasicPopup2 id="persona-popup">
          <div className={styles['popup-container']}>
            <div className={styles['popup-header-container']}>
              <button onClick={() => setAudDeletePopup(false)}>
                <Image
                  src="/icons/CloseBlack.svg"
                  alt="Close"
                  layout="fixed"
                  objectFit="contain"
                  height={24}
                  width={24}
                />
              </button>
            </div>
            <div className={styles['center']}>
              <div>
                <div className={styles['DeleteText']}>
                  <b>Are you sure you want to delete this persona?</b>
                </div>
                <div className={styles['DeleteButtons']}>
                  <BasicButton
                    theme="dark"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Cancel"
                    onClick={() => {
                      setAudDeletePopup(!showAudDeletePopup);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />{' '}
                  <span>&nbsp;</span> <span>&nbsp;</span>
                  <BasicButton
                    theme="red"
                    type="button"
                    loading={loading}
                    disabled={false}
                    text="Delete"
                    image={{
                      src: '/icons/DeleteWhite.svg',
                      height: 16,
                      width: 16,
                    }}
                    onClick={async () => {
                      const id = a8;
                      await deleteAudience({ id });
                      setAudDeletePopup(!showAudDeletePopup);
                    }}
                    extraStyles={{
                      scale: '100%',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </BasicPopup2>
      )}
      <div className={styles['inner-container']}>
        <div className={styles['input-container']}>{getEditor()}</div>
        <div className={styles['output-container']}>
          <OutputTabs editorType={editorType} />
        </div>
      </div>
    </div>
  );
};
